/* eslint-disable react/no-danger */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { SegmentedTabs, TabLayout, Table } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import IndividualRankingCard from '../components/myRankings';
import { getLeaderboardPayload } from '../dashboard/leaderboardWidget/queries';
import {
  getIndividualRankings,
  getLeaderboards,
  getRankings,
  getRankingsListViewOptions,
  getRankingsMeta,
  getRankingsTableInfo,
} from '../selector';
import { fetchDashboardRankings } from '../thunk';
import { getColumns } from './queries';
import styles from '../index.module.scss';

function Leaderboard() {
  const dispatch = useAppDispatch();
  const [activeLeaderboard, setActiveLeaderboard] = useState<{
    code: string;
    name: string;
  } | null>(null);
  const [skipPage] = useState<number>(0);
  const [rankingView, setRankingView] = useState<string>('all');
  const rankingsMeta = useAppSelector(getRankingsMeta);
  const rankings = useAppSelector(getRankings);
  const rankingsListViewOptions = useAppSelector(getRankingsListViewOptions);
  const tableInfo = useAppSelector(getRankingsTableInfo);

  const currentUser = getCurrentUser();
  const leaderboards = useAppSelector(getLeaderboards);
  const individualRanking = useAppSelector(getIndividualRankings);

  useEffect(() => {
    if (activeLeaderboard) {
      dispatch(
        fetchDashboardRankings({
          payload: getLeaderboardPayload(
            { limit: 50, skip: skipPage },
            currentUser.code,
            activeLeaderboard.code,
          ),
        }),
      );
    }
  }, [dispatch, activeLeaderboard, skipPage, rankingView, currentUser.code]);

  useEffect(() => {
    setActiveLeaderboard(leaderboards?.[0] || null);
  }, [leaderboards]);

  return (
    <Widget
      classNames={styles.leaderboardWrapper__widget}
      content={
        <div className={styles.leaderboardWrapper}>
          {Boolean(leaderboards?.length) && (
            <TabLayout
              items={leaderboards?.map((item) => ({
                label: item.name || '',
                key: item.code || '',
              }))}
              defaultKey={activeLeaderboard?.code || ''}
              onChange={(key, item) => setActiveLeaderboard(item)}
            />
          )}
          <div className={styles.leaderboardWrapper__header}>
            <Text type="h5">{activeLeaderboard?.name}</Text>
            <Text type="sublabel">
              <span
                dangerouslySetInnerHTML={{ __html: rankingsMeta?.lastUpdated }}
              />
            </Text>
          </div>
          {!_.isEmpty(individualRanking) && (
            <div className={styles.leaderboardWrapper__individual}>
              <IndividualRankingCard individualRanking={individualRanking} />
            </div>
          )}
          {/* ranking list view type */}
          {Boolean(rankingsListViewOptions?.length > 1) && (
            <div className={styles.leaderboardWrapper__viewOptionTabs}>
              <SegmentedTabs
                tabs={rankingsListViewOptions.map((option) => ({
                  label: option.name,
                  key: option.code,
                }))}
                activeTabKey={rankingView}
                onTabChange={(key) => setRankingView(key)}
              />
            </div>
          )}
          <Table
            tableData={rankings}
            columnConfigs={getColumns(tableInfo?.columns || [])}
            isAccordion={false}
            tableConfig={{
              name: tableInfo?.title,
              showSearch: false,
              isRowSelectionEnabled: false,
              pagination: { visible: true, pageSize: 10, currentPage: 1 },
            }}
          />
        </div>
      }
    />
  );
}

export default Leaderboard;
